import { PDFAction as PDFActionComponent } from './PDFAction';
import { withContainer } from './withContainer';

const PDFAction = withContainer(
  PDFActionComponent,
);

export { PDFAction, PDFActionComponent };
export * from './withContainer';
